// Drop Down Action Type

export const TIMER_DROP_DOWN = "TIMER_DROP_DOWN";
export const TIMER_DROP_DOWN_SUCCESS = "TIMER_DROP_DOWN_SUCCESS";
export const TIMER_DROP_DOWN_FAILURE = "TIMER_DROP_DOWN_FAILURE";
